import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

import Stack from '@mui/material/Stack';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import {alpha} from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import axios from "axios";

function Section({ user, updateUser, courseId, sectionId, sectionTitle, setSectionTitle, saveSection, open, setOpen }) {
    const { t } = useTranslation();
    const [starttime, setStarttime] = useState(new Date().getTime());
    const [token, setToken] = useState(sessionStorage.getItem('mISLec_access_token'))

    React.useEffect(() => {
        return () => {
            if (sectionId) {
                let endtime = new Date().getTime()

                // time spent in ms
                const timeSpent = endtime - starttime

                axios.put(`${process.env.REACT_APP_API}/api/users/${user._id}/statistic`, {
                    course_id: courseId,
                    section_id: sectionId,
                    time_spent: timeSpent
                }, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem('mISLec_access_token') || token.toString()}`
                    }
                }).then((res) => {
                    console.log('Res', res);
                }).catch((error) => {
                    //  Expired session
                    if (error.response)
                        if (error.response.data.detail === 'api.auth.verify.401')
                            updateUser(null);
                })
            }
            setStarttime(new Date().getTime());
        }
    }, [sectionId, courseId])

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Paper
                sx={{
                    padding: '24px',
                    minWidth: { xs: '95%', md: '35%' },
                    maxWidth: { xs: '95%', md: '35%' },
                }}
            >
                <Typography variant='h6' sx={{ mb: 4 }}>
                    {t('course.modals.newSection.title')}
                </Typography>
                <Stack spacing={4}>
                    <TextField
                        id='mISLec_section_title'
                        label={t('course.modals.newSection.input')}
                        variant='outlined'
                        value={sectionTitle ? sectionTitle : ''}
                        onChange={(e) => setSectionTitle(e.target.value)}
                        fullWidth
                    />
                </Stack>
                <Stack
                    direction='row'
                    alignItems='center'
                    mt={4}
                    sx={{
                        justifyContent: {
                            xs: 'space-between',
                            md: 'flex-end'
                        }
                    }}
                >
                    <Button
                        variant=''
                        onClick={() => setOpen(false)}
                        sx={{
                            borderRadius: '8px !important',
                            backgroundColor: (theme) => ({
                                xs: alpha(theme.palette.error.main, 0.08),
                                md: 'rgba(33, 43, 54, 0.08)'
                            }),
                            color: {
                                xs: 'error.main',
                                md: 'inherit'
                            },
                            '&:hover': {
                                color: 'error.main',
                                backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08)
                            }
                        }}
                    >
                        {t('course.modals.newSection.cancel')}
                    </Button>
                    <Button
                        onClick={() => saveSection()}
                        sx={{
                            ml: {
                                xs: 0,
                                md: 1
                            },
                            borderRadius: '8px !important',
                            backgroundColor: (theme) => ({
                                xs: alpha(theme.palette.primary.main, 0.08),
                                md: 'rgba(33, 43, 54, 0.08)'
                            }),
                            color: {
                                xs: 'primary.main',
                                md: 'inherit'
                            },
                            '&:hover': {
                                color: 'primary.main',
                                backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08)
                            }
                        }}
                    >
                        {t('course.modals.newSection.create')}
                    </Button>
                </Stack>
            </Paper>
        </Modal>
    );
}

export default Section;